"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }


// How many chats one user may pin, archived ones included. The server
// enforces it; this is only for copy.
 const PIN_LIMIT = 10; exports.PIN_LIMIT = PIN_LIMIT
 const PIN_LIMIT_REACHED = 'pin_limit_reached'; exports.PIN_LIMIT_REACHED = PIN_LIMIT_REACHED
 const PIN_LIMIT_MESSAGE = `You can pin up to ${exports.PIN_LIMIT} chats, including archived ones. Unpin one to pin this chat.`; exports.PIN_LIMIT_MESSAGE = PIN_LIMIT_MESSAGE



// When I pinned the chat, or null when I haven't.
 const myPinnedAt = (b, myUserKey) =>
  _optionalChain([(_optionalChain([b, 'access', _ => _.UserMetadata, 'optionalAccess', _2 => _2[myUserKey]]) ), 'optionalAccess', _3 => _3.PinnedAt]) || null; exports.myPinnedAt = myPinnedAt

 const isPinnedByMe = (b, myUserKey) => !!exports.myPinnedAt.call(void 0, b, myUserKey); exports.isPinnedByMe = isPinnedByMe



// Whether a pin may show before the server takes it. Only the server sees
// every pin (archived ones are not loaded), so once the pins this client
// knows of are one short of the limit, the row waits for the answer: a pin
// past the limit then never moves it.
 const canPinOptimistically = (knownPins) => knownPins < exports.PIN_LIMIT - 1; exports.canPinOptimistically = canPinOptimistically

// My pin time after one step of SetBlobjectPinned, or undefined for no
// change. Unpin shows at once; Pin at once when Optimistic, else once the
// server takes it. A failure puts back what was there.
 const pinnedAtAfter = (phase, { PinnedAt, Previous, Optimistic }) => {
  if (phase === 'failure') return Previous
  if (phase === 'request') return !PinnedAt ? null : Optimistic ? PinnedAt : undefined
  return PinnedAt && !Optimistic ? PinnedAt : undefined
}; exports.pinnedAtAfter = pinnedAtAfter

// The server's refusal of an 11th pin (a CommandError whose extra carries
// the ErrorCode).
 const isPinLimitError = (e) =>
  _optionalChain([(e ), 'optionalAccess', _4 => _4.extra, 'optionalAccess', _5 => _5.ErrorCode]) === exports.PIN_LIMIT_REACHED; exports.isPinLimitError = isPinLimitError
